exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-3bffa9de]{font-weight:bold;font-size:18px}.success[data-v-3bffa9de]{color:#52c41a}.error[data-v-3bffa9de]{color:red}", ""]);

// exports
